module.exports = "/images/bw.svg?480341a9645841582a54d110fa76b030";